var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3"},[_c('FormConfiguraciones',{ref:"form",attrs:{"error-message":'',"loading":_vm.loading,"configuracion":_vm.configuraciones},on:{"save":_vm.saveItem,"newInstance":_vm.newInstance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }